import { config } from "../../config";
import { SubledgerEndpoints } from "../../SubledgerEndpoints";
import { authGet } from "../../services/RequestHelpers";
import { IUserProviderState } from "../../contexts/UserContext";

export enum Tiles {
  AuthorMyDrafts = "AuthorMyDrafts",
  AuthorSendToPoster = "AuthorSendToPoster",
  RequestorSignOffRequested = "RequestorSignOffRequested",
  RequestorMyPendingClarifications = "RequestorMyPendingClarifications",
  RequestorReadyToPost = "RequestorReadyToPost",
  ReviewerSignOffPending = "ReviewerSignOffPending",
  ReviewerAwaitingClarifications = "ReviewerAwaitingClarifications"
}

export type userTypeIndex =
  | "My Draft's"
  | "Send To Poster"
  | "Sign Off Requested"
  | "My Pending Clarifications" // Use this for post
  | "Ready To Post" // Use this for post
  | "Sign Off Pending"
  | "Awaiting Clarifications";

export type ISlUserTiles = {
  [key in userTypeIndex]: ITile;
};

export interface ITile {
  tileName: string;
  tileCount: number;
  tileDisplayName: string;
  allowActionLinks: number[];
}

export async function getTileCount(getTokenFn: IUserProviderState["accessToken"]): Promise<ITile[]> {
  const slPeronasUrl = config.get("subledgerUrl") + SubledgerEndpoints.slTileCount;
  const result = await authGet(slPeronasUrl, getTokenFn);
  return result.data as ITile[];
}

export async function fetchTiles(
  tokenPromise: () => Promise<any>,
  fetchFunction: typeof getTileCount = getTileCount
): Promise<ISlUserTiles | undefined> {
  const tiles = await fetchFunction(tokenPromise);
  if (tiles.every((tile) => tile.tileCount === 0)) {
    return;
  }
  const userEntries = tiles.reduce((ctr, tile: ITile) => {
    if (tile.tileCount > 0) {
      ctr[tile.tileDisplayName as userTypeIndex] = tile;
    }
    return ctr;
  }, {} as ISlUserTiles);
  return userEntries;
}
